import { AddtionalEntity } from "../Addtional/AddtionalEntity"
import { BaseModel } from "../Generics/BaseModel"
import { addtionalMemory } from "../Memory/Memory"

export class GenericOrderFoodAdditionalEntity extends BaseModel {
  id: number

  genericOrderFoodId: number

  addtionalEntityId: number

  amount: number

  valueTotal: number

  valueUnique: number

  isFree: boolean

  addtionalEntity: AddtionalEntity

  constructor(data: Partial<GenericOrderFoodAdditionalEntity> = {}) {
    super()

    this.id = data.id ?? -1

    this.genericOrderFoodId = data.genericOrderFoodId ?? -1

    this.addtionalEntityId = data.addtionalEntityId ?? -1

    this.valueTotal = data.valueTotal ?? 0

    this.valueUnique = data.valueUnique ?? 0

    this.amount = data.amount ?? 0

    this.isFree = data.isFree ?? false

    if (data.addtionalEntity) {
      this.addtionalEntity = new AddtionalEntity(data.addtionalEntity)
    } else if (this.addtionalEntityId !== -1) {
      this.addtionalEntity = addtionalMemory.findById(this.addtionalEntityId) ?? new AddtionalEntity()
    } else {
      this.addtionalEntity = new AddtionalEntity()
    }
  }

  protected override getJsonFields(): string[] {
    return ["addtionalEntityId", "amount"]
  }

  calculate() {
    this.valueUnique = this.isFree ? 0 : this.valueUnique
    this.valueTotal = this.valueUnique * this.amount
  }
}
